// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 928 ? "e18fe737" : chunkId) + "." + {"150":"9de94783f4fc28da","808":"ba5887f79b94a8b3","928":"5e48ba5b45862377","995":"fa088735c5c4cab9"}[chunkId] + ".js";
};